/**
 * 接口地址
 * */
//预发布 /pre
let env = process.env.VUE_APP_ENV

let baseUrl
if (env === 'development') {
   //baseUrl = 'https://bigdata-gateway-dev.speedtest.cn'
   baseUrl = '/api'
} else if (env === 'pre') {
   //baseUrl = 'https://bigdata-speed-result-pre.speedtest.cn'
   //baseUrl = 'https://bigdata-gateway-pre.speedtest.cn'
   baseUrl = '/api'
} else if (env === 'production') {
   //baseUrl = 'https://bigdata-speed-result.speedtest.cn/'
   baseUrl = '/api'
}



export {
   baseUrl
}

